import { JSX } from 'react'

import { IconProps } from '../../icon'

const ToDo: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 33 32'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_671_67)'>
      <path
        d='M32.5141 16L28.8916 11.978L29.4587 6.59361L24.1617 5.47218L21.4596 0.778259L16.5141 2.98846L11.5687 0.778259L8.86661 5.47218L3.56952 6.59361L4.13665 11.978L0.514099 16L4.13658 20.0219L3.56945 25.4063L8.86655 26.5278L11.5686 31.2217L16.5141 29.0114L21.4595 31.2217L24.1616 26.5278L29.4587 25.4063L28.8915 20.0219L32.5141 16ZM16.5141 26.9553L12.35 28.8163L10.0754 24.8648L5.6137 23.9203L6.09116 19.387L3.04062 16L6.09116 12.6131L5.6137 8.0798L10.0754 7.13521L12.35 3.18376L16.5141 5.04472L20.6782 3.18376L22.9528 7.13521L27.4146 8.0798L26.9371 12.6131L29.9876 16L26.937 19.3869L27.4145 23.9201L22.9527 24.8647L20.6781 28.8162L16.5141 26.9553Z'
        fill='#BFBFBF'
      />
      <path
        d='M21.8212 11.2465L15.1128 18.7622L10.9368 14.5862L9.60939 15.9137L15.1903 21.4946L23.2217 12.4966L21.8212 11.2465Z'
        fill='#BFBFBF'
      />
    </g>
    <defs>
      <clipPath id='clip0_671_67'>
        <rect
          width='32'
          height='32'
          fill='white'
          transform='translate(0.514099)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default ToDo
